import React, { useState, useEffect } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../utils/firebase'; // Өөрийн firebase тохиргоог холбоно уу
import logo from "../../assets/logo7.png";

const SupportPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSent, setIsSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [activeFaq, setActiveFaq] = useState(null);
  
  // 🌟 ХЭЛ СОЛИХ ТӨЛӨВ (MN эсвэл EN)
  const [lang, setLang] = useState('mn'); 

  // 🌟 АВТОМАТ VIEWPORT ТОХИРУУЛАГЧ
  useEffect(() => {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    let originalContent = '';

    if (viewportMeta) {
      originalContent = viewportMeta.getAttribute('content');
      viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }

    return () => {
      if (viewportMeta && originalContent) {
        viewportMeta.setAttribute('content', originalContent);
      }
    };
  }, []); 

  // 🌟 ХЭЛНИЙ МЭДЭЭЛЛҮҮД (TRANSLATIONS)
  const t = {
    mn: {
      title: "Танд юугаар туслах вэ?",
      subtitle: "Бид танд 24/7 туслахад бэлэн байна",
      systemRules: "Системийн дүрэм",
      rule1Title: "Нэг хаяг - Нэг төхөөрөмж",
      rule1Desc: "Аюулгүй байдлын үүднээс таны бүртгэл зөвхөн нэг л ухаалаг утсанд холбогдож ажиллана. Нэг хаягаар олон утсанд зэрэг нэвтрэх боломжгүй бөгөөд өөр утсаар орох бол өмнөх төхөөрөмжөөсөө заавал Гарах (Logout) шаардлагатайг анхаарна уу.",
      rule2Title: "Зогсоолд ойрхон байх",
      rule2Desc: "Хаалтыг нээхийн тулд та зогсоолын төхөөрөмжид хангалттай ойрхон (ойролцоогоор 2-3 метр) очсон байх шаардлагатай. Холоос 'Радар' дарах үед систем хариу үйлдэл үзүүлэхгүй.",
      howToVip: "VIP эрх хэрхэн авах вэ?",
      step1Title: "Хүсэлтийн код оруулах",
      step1Desc: "Та зогсоол эзэмшигч байгууллага эсвэл СӨХ-өөс өгсөн 6 оронтой 'Хүсэлтийн код'-ыг аппликейшний 'Урилгаар нэвтрэх' хэсэгт оруулж илгээнэ.",
      step2Title: "Баталгаажуулалт хүлээх",
      step2Desc: "Таны илгээсэн хүсэлтийг байгууллагын админ хянаж үзсэний дараа системд баталгаажуулна. Энэ хүртэл таны эрх хүлээгдэж буй төлөвтэй байна.",
      step3Title: "VIP эрх идэвхжих",
      step3Desc: "Батлагдсаны дараа таны апп дээрх төлөв 'VIP' болон өөрчлөгдөх бөгөөд тухайн зогсоолын хаалтад очиход ямар нэгэн төлбөргүйгээр автоматаар нэвтэрнэ.",
      step4Title: "Сар бүрийн сунгалт",
      step4Desc: "VIP эрхийн хугацаа дуусах үед та апп-аараа дамжуулан сарын хураамжаа автоматаар төлж, эрхээ сунгах боломжтой.",
      contactUs: "Шууд холбоо барих",
      emailBtn: "И-мэйл бичих",
      emailSendBtn: "Имэйл илгээх",
      phoneBtn: "Утсаар холбогдох",
      workHours: "Даваа-Баасан, 09:00 - 18:00",
      sendFeedback: "Санал хүсэлт илгээх",
      nameLabel: "Таны нэр",
      namePlaceholder: "Жишээ нь: Бат",
      emailLabel: "И-мэйл хаяг",
      emailPlaceholder: "name@example.com",
      messageLabel: "Мессеж",
      messagePlaceholder: "Асуух зүйлээ энд бичнэ үү...",
      submitBtn: "Хүсэлт илгээх",
      sendingBtn: "Илгээж байна...",
      successMsg: "Амжилттай илгээгдлээ.",
      errorMsg: "Уучлаарай, илгээх үед алдаа гарлаа. Та дахин оролдоно уу.",
      faqTitle: "Түгээмэл асуултууд",
      faqs: [
        {
          q: "Шинэ утсаар нэвтэрч болохгүй байна?",
          a: "Та манай системийг нэгэн зэрэг олон утсан дээр ашиглах боломжгүй. Хэрэв та утсаа сольсон бол хуучин утасныхаа апп дотроос 'Системээс гарах' товчийг дарж гарсны дараа шинэ утсаар нэвтэрнэ үү."
        },
        {
          q: "Зогсоолын хаалт онгойхгүй байвал яах вэ?",
          a: "Та апп-аа унтрааж асаагаад интернэт холболтоо шалгана уу. Мөн хаалтанд хангалттай ойрхон (2-3 метр) очсон эсэхээ шалгаарай. Хэрэв болохгүй бол манай тусламжийн утсаар холбогдож тусламж авна уу."
        },
        {
          q: "Төлбөр төлсөн ч баталгаажихгүй байвал яах вэ?",
          a: "Банкны гүйлгээний саатлаас үүдэн 1-3 минут хүлээгдэх тохиолдол гардаг. Та гүйлгээний утгаа зөв бичсэн эсэхээ шалгаад бидэнтэй холбогдоно уу."
        },
        {
          q: "Бүртгэлтэй машины дугаараа хэрхэн солих вэ?",
          a: "Аппликэйшний 'Профайл' цэс рүү орж 'Машины дугаар' хэсэгт шинэ дугаараа оруулан хадгалах товчийг дарна уу."
        },
        {
          q: "VIP эрхийн хугацаа дууссан бол яах вэ?",
          a: "Таны VIP эрх дууссан үед хаалт автоматаар нээгдэхгүй бөгөөд та энгийн хэрэглэгч шиг цагийн төлбөрөө төлж гарах шаардлагатай болно. Эрхээ цаг тухайд нь апп дотроосоо сунгана уу."
        }
      ]
    },
    en: {
      title: "How can we help you?",
      subtitle: "We are ready to assist you 24/7",
      systemRules: "System Rules",
      rule1Title: "One Account - One Device",
      rule1Desc: "For security reasons, your account can only be linked to one smartphone at a time. Simultaneous login on multiple devices is not possible. If you need to use a new device, please Logout from the previous one first.",
      rule2Title: "Be close to the barrier",
      rule2Desc: "To open the barrier, you must be close enough (approx. 2-3 meters) to the parking device. The system will not respond if you use the 'Radar' from a far distance.",
      howToVip: "How to get VIP access?",
      step1Title: "Enter request code",
      step1Desc: "Enter the 6-digit 'Request Code' provided by the parking owner or building management in the 'Login via Invitation' section of the app.",
      step2Title: "Wait for approval",
      step2Desc: "Your request will be reviewed by the admin. Until then, your access status will remain pending.",
      step3Title: "VIP Activation",
      step3Desc: "Once approved, your app status will change to 'VIP', allowing you to enter the specific parking area automatically without any charges.",
      step4Title: "Monthly Renewal",
      step4Desc: "When your VIP period expires, you can automatically pay your monthly fee through the app to extend your access.",
      contactUs: "Contact Us Directly",
      emailBtn: "Send an Email",
      emailSendBtn: "Send Email",
      phoneBtn: "Call Us",
      workHours: "Mon-Fri, 09:00 - 18:00",
      sendFeedback: "Send Feedback",
      nameLabel: "Your Name",
      namePlaceholder: "e.g: John Doe",
      emailLabel: "Email Address",
      emailPlaceholder: "name@example.com",
      messageLabel: "Message",
      messagePlaceholder: "Write your question here...",
      submitBtn: "Submit",
      sendingBtn: "Sending...",
      successMsg: "Message sent successfully.",
      errorMsg: "Sorry, an error occurred while sending. Please try again.",
      faqTitle: "Frequently Asked Questions",
      faqs: [
        {
          q: "Cannot login with a new phone?",
          a: "You cannot use our system on multiple phones simultaneously. If you changed your phone, please open the app on your old phone and click 'Logout' before logging into the new one."
        },
        {
          q: "Barrier doesn't open when Radar is pressed?",
          a: "Restart your app and check your internet connection. Also, make sure you are close enough (2-3 meters) to the barrier. If it still doesn't work, contact our support for remote assistance."
        },
        {
          q: "Payment made but not confirmed?",
          a: "Bank transactions may be delayed by 1-3 minutes. Please ensure you entered the correct transaction description and contact us if the issue persists."
        },
        {
          q: "How to change registered plate number?",
          a: "Go to the 'Profile' menu in the app, enter your new plate number in the 'Car Number' section, and click save."
        },
        {
          q: "What if VIP access expires?",
          a: "When your VIP expires, the barrier will not open automatically, and you will have to pay the hourly rate like a regular user. Please renew your subscription on time."
        }
      ]
    }
  };

  const currentT = t[lang]; // Одоогийн сонгогдсон хэлний объектууд

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await addDoc(collection(db, 'feedbacks'), {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        createdAt: serverTimestamp(), 
      });

      setIsSent(true);
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setIsSent(false), 5000);
    } catch (err) {
      console.error("Алдаа: ", err);
      setError(currentT.errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="tw-min-h-screen tw-bg-slate-50 tw-text-slate-900 tw-relative tw-overflow-hidden tw-font-sans">
      
      {/* 🌟 ХЭЛ СОЛИХ ТОВЧ 🌟 */}
      <div className="tw-absolute tw-top-6 tw-right-6 tw-z-50 tw-bg-white/20 tw-backdrop-blur-md tw-rounded-full tw-border tw-border-white/10 tw-shadow-lg tw-flex tw-p-1">
        <button 
          onClick={() => setLang('mn')}
          className={`tw-px-4 tw-py-2 tw-rounded-full tw-text-sm tw-font-bold tw-transition-all ${lang === 'mn' ? 'tw-bg-white tw-text-emerald-600 tw-shadow-md' : 'tw-text-white/70 hover:tw-text-white'}`}
        >
          MN
        </button>
        <button 
          onClick={() => setLang('en')}
          className={`tw-px-4 tw-py-2 tw-rounded-full tw-text-sm tw-font-bold tw-transition-all ${lang === 'en' ? 'tw-bg-white tw-text-emerald-600 tw-shadow-md' : 'tw-text-white/70 hover:tw-text-white'}`}
        >
          EN
        </button>
      </div>

      {/* Background Glow Effects */}
      <div className="tw-absolute tw-w-[400px] tw-h-[400px] tw-bg-emerald-400/20 tw-rounded-full tw-blur-[100px] -tw-top-20 -tw-right-20 tw-z-0 tw-hidden md:tw-block"></div>
      <div className="tw-absolute tw-w-[500px] tw-h-[500px] tw-bg-blue-400/10 tw-rounded-full tw-blur-[100px] -tw-bottom-40 -tw-left-40 tw-z-0 tw-hidden md:tw-block"></div>

      {/* Header Section */}
      <div className="tw-bg-gradient-to-br tw-from-slate-900 tw-to-slate-800 tw-pt-16 md:tw-pt-20 tw-pb-24 md:tw-pb-32 tw-px-6 tw-text-center tw-relative tw-z-10">
        <div className="tw-max-w-3xl tw-mx-auto tw-flex tw-flex-col tw-items-center">
          
          <div className="tw-w-40 tw-h-40 md:tw-w-48 md:tw-h-48 tw-mb-6 tw-bg-white tw-rounded-3xl tw-p-3 tw-shadow-2xl tw-shadow-emerald-500/20 tw-border tw-border-slate-700">
            <img 
              src={logo} 
              alt="IParking Logo" 
              className="tw-w-full tw-h-full tw-object-contain" 
            />
          </div>

          <h1 className="tw-text-3xl md:tw-text-5xl tw-font-extrabold tw-tracking-tight tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-white tw-to-emerald-200 tw-m-0">
            {currentT.title}
          </h1>
          <p className="tw-mt-4 tw-text-base md:tw-text-lg tw-text-slate-400 tw-font-medium">
            {currentT.subtitle}
          </p>
        </div>
      </div>

      {/* Main Content Wrapper */}
      <div className="tw-max-w-5xl tw-mx-auto -tw-mt-12 md:-tw-mt-16 tw-px-4 md:tw-px-8 tw-pb-20 tw-relative tw-z-20">
        
        {/* 🌟 1. СИСТЕМИЙН ДҮРЭМ */}
        <div className="tw-mb-10 md:tw-mb-16">
          <h3 className="tw-text-sm tw-font-bold tw-text-slate-400 tw-tracking-widest tw-mb-6 tw-pl-2 uppercase">{currentT.systemRules}</h3>
          <div className="tw-flex tw-flex-col tw-gap-4">
            <div className="tw-bg-white tw-rounded-2xl tw-p-6 md:tw-p-8 tw-border tw-border-slate-100 tw-shadow-lg tw-shadow-slate-200/40 tw-flex tw-gap-4 md:tw-gap-6 tw-items-start">
              <div className="tw-p-3 md:tw-p-4 tw-bg-red-50 tw-rounded-full tw-shrink-0">
                <svg className="tw-w-6 tw-h-6 md:tw-w-8 md:tw-h-8 tw-text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <div>
                <h4 className="tw-text-lg md:tw-text-xl tw-font-bold tw-text-slate-900 tw-mb-2 tw-mt-1">{currentT.rule1Title}</h4>
                <p className="tw-text-slate-600 tw-text-sm md:tw-text-base tw-leading-relaxed tw-m-0">
                  {currentT.rule1Desc}
                </p>
              </div>
            </div>
            <div className="tw-bg-white tw-rounded-2xl tw-p-6 md:tw-p-8 tw-border tw-border-slate-100 tw-shadow-lg tw-shadow-slate-200/40 tw-flex tw-gap-4 md:tw-gap-6 tw-items-start">
              <div className="tw-p-3 md:tw-p-4 tw-bg-blue-50 tw-rounded-full tw-shrink-0">
                <svg className="tw-w-6 tw-h-6 md:tw-w-8 md:tw-h-8 tw-text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h4 className="tw-text-lg md:tw-text-xl tw-font-bold tw-text-slate-900 tw-mb-2 tw-mt-1">{currentT.rule2Title}</h4>
                <p className="tw-text-slate-600 tw-text-sm md:tw-text-base tw-leading-relaxed tw-m-0">
                  {currentT.rule2Desc}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 🌟 2. VIP ЭРХ АВАХ ЗААВАР (Timeline) */}
        <div className="tw-mb-12 md:tw-mb-20">
          <h3 className="tw-text-sm tw-font-bold tw-text-slate-400 tw-tracking-widest tw-mb-6 tw-pl-2 uppercase">{currentT.howToVip}</h3>
          <div className="tw-bg-white tw-rounded-3xl tw-p-8 md:tw-p-10 tw-border tw-border-slate-100 tw-shadow-xl tw-shadow-slate-200/40">
            
            {/* Step 1 */}
            <div className="tw-flex tw-gap-4 md:tw-gap-6">
              <div className="tw-flex tw-flex-col tw-items-center">
                <div className="tw-w-8 tw-h-8 md:tw-w-10 md:tw-h-10 tw-rounded-full tw-border-2 tw-border-slate-300 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-text-slate-700 tw-font-bold tw-text-sm md:tw-text-base tw-z-10">1</div>
                <div className="tw-w-0.5 tw-h-full tw-bg-slate-200 tw-my-2"></div>
              </div>
              <div className="tw-pb-8 md:tw-pb-10">
                <h4 className="tw-text-base md:tw-text-lg tw-font-bold tw-text-slate-900 tw-mb-2 tw-mt-1 md:tw-mt-2">{currentT.step1Title}</h4>
                <p className="tw-text-slate-600 tw-text-sm md:tw-text-base tw-leading-relaxed tw-m-0">{currentT.step1Desc}</p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="tw-flex tw-gap-4 md:tw-gap-6">
              <div className="tw-flex tw-flex-col tw-items-center">
                <div className="tw-w-8 tw-h-8 md:tw-w-10 md:tw-h-10 tw-rounded-full tw-border-2 tw-border-slate-300 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-text-slate-700 tw-font-bold tw-text-sm md:tw-text-base tw-z-10">2</div>
                <div className="tw-w-0.5 tw-h-full tw-bg-slate-200 tw-my-2"></div>
              </div>
              <div className="tw-pb-8 md:tw-pb-10">
                <h4 className="tw-text-base md:tw-text-lg tw-font-bold tw-text-slate-900 tw-mb-2 tw-mt-1 md:tw-mt-2">{currentT.step2Title}</h4>
                <p className="tw-text-slate-600 tw-text-sm md:tw-text-base tw-leading-relaxed tw-m-0">{currentT.step2Desc}</p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="tw-flex tw-gap-4 md:tw-gap-6">
              <div className="tw-flex tw-flex-col tw-items-center">
                <div className="tw-w-8 tw-h-8 md:tw-w-10 md:tw-h-10 tw-rounded-full tw-border-2 tw-border-slate-300 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-text-slate-700 tw-font-bold tw-text-sm md:tw-text-base tw-z-10">3</div>
                <div className="tw-w-0.5 tw-h-full tw-bg-slate-200 tw-my-2"></div>
              </div>
              <div className="tw-pb-8 md:tw-pb-10">
                <h4 className="tw-text-base md:tw-text-lg tw-font-bold tw-text-slate-900 tw-mb-2 tw-mt-1 md:tw-mt-2">{currentT.step3Title}</h4>
                <p className="tw-text-slate-600 tw-text-sm md:tw-text-base tw-leading-relaxed tw-m-0">{currentT.step3Desc}</p>
              </div>
            </div>

            {/* Step 4 (Last) */}
            <div className="tw-flex tw-gap-4 md:tw-gap-6">
              <div className="tw-flex tw-flex-col tw-items-center">
                <div className="tw-w-8 tw-h-8 md:tw-w-10 md:tw-h-10 tw-rounded-full tw-border-2 tw-border-emerald-500 tw-bg-emerald-50 tw-flex tw-items-center tw-justify-center tw-text-emerald-600 tw-font-bold tw-text-sm md:tw-text-base tw-z-10">4</div>
              </div>
              <div>
                <h4 className="tw-text-base md:tw-text-lg tw-font-bold tw-text-emerald-600 tw-mb-2 tw-mt-1 md:tw-mt-2">{currentT.step4Title}</h4>
                <p className="tw-text-slate-600 tw-text-sm md:tw-text-base tw-leading-relaxed tw-m-0">{currentT.step4Desc}</p>
              </div>
            </div>

          </div>
        </div>

        {/* 🌟 3. ХОЛБОО БАРИХ КАРТУУД */}
        <h3 className="tw-text-sm tw-font-bold tw-text-slate-400 tw-tracking-widest tw-mb-6 tw-pl-2 uppercase">{currentT.contactUs}</h3>
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 md:tw-gap-6 tw-mb-10 md:tw-mb-16">
          {/* Email Card */}
          <a href="mailto:iparkingiparking@gmail.com" className="tw-bg-white/90 tw-backdrop-blur-md tw-rounded-2xl md:tw-rounded-3xl tw-p-6 md:tw-p-8 tw-text-center tw-border tw-border-slate-100 tw-shadow-lg md:tw-shadow-xl tw-shadow-slate-200/50 hover:-tw-translate-y-1 hover:tw-shadow-xl hover:tw-border-emerald-500/20 tw-transition-all tw-duration-300 tw-group tw-cursor-pointer tw-no-underline">
            <div className="tw-w-14 tw-h-14 md:tw-w-16 md:tw-h-16 tw-mx-auto tw-mb-4 md:tw-mb-6 tw-rounded-xl md:tw-rounded-2xl tw-bg-gradient-to-br tw-from-emerald-400 tw-to-emerald-600 tw-text-white tw-flex tw-items-center tw-justify-center tw-shadow-md tw-shadow-emerald-500/30">
              <svg className="tw-w-6 tw-h-6 md:tw-w-7 md:tw-h-7" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="tw-text-lg md:tw-text-xl tw-font-bold tw-text-slate-900 tw-mb-2">{currentT.emailBtn}</h3>
            <p className="tw-text-slate-600 tw-font-medium tw-m-0">iparkingiparking@gmail.com</p>
            <span className="tw-inline-block tw-mt-4 tw-text-emerald-500 tw-font-semibold group-hover:tw-text-emerald-600 tw-transition-colors">
              {currentT.emailSendBtn} &rarr;
            </span>
          </a>

          {/* Phone Card */}
          <a href="tel:+97688551180" className="tw-bg-white/90 tw-backdrop-blur-md tw-rounded-2xl md:tw-rounded-3xl tw-p-6 md:tw-p-8 tw-text-center tw-border tw-border-slate-100 tw-shadow-lg md:tw-shadow-xl tw-shadow-slate-200/50 hover:-tw-translate-y-1 hover:tw-shadow-xl hover:tw-border-emerald-500/20 tw-transition-all tw-duration-300 tw-group tw-no-underline">
            <div className="tw-w-14 tw-h-14 md:tw-w-16 md:tw-h-16 tw-mx-auto tw-mb-4 md:tw-mb-6 tw-rounded-xl md:tw-rounded-2xl tw-bg-gradient-to-br tw-from-emerald-400 tw-to-emerald-600 tw-text-white tw-flex tw-items-center tw-justify-center tw-shadow-md tw-shadow-emerald-500/30">
              <svg className="tw-w-6 tw-h-6 md:tw-w-7 md:tw-h-7" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <h3 className="tw-text-lg md:tw-text-xl tw-font-bold tw-text-slate-900 tw-mb-2">{currentT.phoneBtn}</h3>
            <p className="tw-text-slate-600 tw-font-medium tw-m-0">+976 88551180</p>
            <p className="tw-text-xs md:tw-text-sm tw-text-slate-400 tw-mt-2 tw-mb-0">{currentT.workHours}</p>
          </a>
        </div>

        {/* 🌟 4. FORM & FAQ ХЭСЭГ */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 lg:tw-gap-12 tw-mb-16">
          
          {/* Contact Form */}
          <div>
            <h3 className="tw-text-sm tw-font-bold tw-text-slate-400 tw-tracking-widest tw-mb-6 tw-pl-2 uppercase">{currentT.sendFeedback}</h3>
            <div className="tw-bg-white tw-p-6 md:tw-p-10 tw-rounded-2xl md:tw-rounded-3xl tw-shadow-xl tw-shadow-slate-200/50 tw-border tw-border-slate-100">
              {error && (
                <div className="tw-p-4 tw-rounded-xl tw-mb-6 tw-bg-red-50 tw-text-red-700 tw-border tw-border-red-200 tw-font-medium tw-text-sm md:tw-text-base">
                  {error}
                </div>
              )}
              {isSent && (
                <div className="tw-p-4 tw-rounded-xl tw-mb-6 tw-bg-emerald-50 tw-text-emerald-800 tw-border tw-border-emerald-200 tw-font-medium tw-flex tw-items-center tw-gap-3 tw-text-sm md:tw-text-base">
                  <span>✅</span> {currentT.successMsg}
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-gap-5 md:tw-gap-6">
                <div className="tw-flex tw-flex-col tw-gap-2">
                  <label className="tw-text-sm tw-font-semibold tw-text-slate-600 tw-pl-1">{currentT.nameLabel}</label>
                  <input 
                    type="text" 
                    required
                    className="tw-w-full tw-px-4 tw-py-3 md:tw-py-4 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50 focus:tw-bg-white focus:tw-border-emerald-500 focus:tw-ring-4 focus:tw-ring-emerald-500/10 tw-transition-all tw-outline-none tw-text-slate-900 placeholder:tw-text-slate-400" 
                    placeholder={currentT.namePlaceholder}
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                  />
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2">
                  <label className="tw-text-sm tw-font-semibold tw-text-slate-600 tw-pl-1">{currentT.emailLabel}</label>
                  <input 
                    type="email" 
                    required
                    className="tw-w-full tw-px-4 tw-py-3 md:tw-py-4 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50 focus:tw-bg-white focus:tw-border-emerald-500 focus:tw-ring-4 focus:tw-ring-emerald-500/10 tw-transition-all tw-outline-none tw-text-slate-900 placeholder:tw-text-slate-400" 
                    placeholder={currentT.emailPlaceholder}
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                  />
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2">
                  <label className="tw-text-sm tw-font-semibold tw-text-slate-600 tw-pl-1">{currentT.messageLabel}</label>
                  <textarea 
                    required
                    className="tw-w-full tw-px-4 tw-py-3 md:tw-py-4 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50 focus:tw-bg-white focus:tw-border-emerald-500 focus:tw-ring-4 focus:tw-ring-emerald-500/10 tw-transition-all tw-outline-none tw-text-slate-900 placeholder:tw-text-slate-400 tw-h-32 md:tw-h-36 tw-resize-y" 
                    placeholder={currentT.messagePlaceholder}
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                  />
                </div>
                <button 
                  type="submit" 
                  className="tw-w-full tw-mt-2 tw-bg-gradient-to-r tw-from-emerald-500 tw-to-emerald-600 tw-text-white tw-py-3 md:tw-py-4 tw-rounded-xl tw-font-semibold tw-text-base md:tw-text-lg tw-shadow-lg tw-shadow-emerald-500/30 hover:-tw-translate-y-1 hover:tw-shadow-emerald-500/40 active:tw-translate-y-0 tw-transition-all disabled:tw-opacity-70 disabled:tw-cursor-not-allowed tw-flex tw-justify-center tw-items-center"
                  disabled={isLoading || isSent}
                >
                  {isLoading ? (
                    <div className="tw-flex tw-items-center tw-gap-2">
                      <div className="tw-w-5 tw-h-5 md:tw-w-6 md:tw-h-6 tw-border-2 tw-border-white/30 tw-border-t-white tw-rounded-full tw-animate-spin"></div>
                      <span>{currentT.sendingBtn}</span>
                    </div>
                  ) : (
                    currentT.submitBtn
                  )}
                </button>
              </form>
            </div>
          </div>

          {/* FAQ Section */}
          <div>
            <h3 className="tw-text-sm tw-font-bold tw-text-slate-400 tw-tracking-widest tw-mb-6 tw-pl-2 uppercase">{currentT.faqTitle}</h3>
            <div className="tw-flex tw-flex-col tw-gap-3 md:tw-gap-4">
              {currentT.faqs.map((faq, index) => (
                <div 
                  key={index} 
                  onClick={() => toggleFaq(index)}
                  className={`tw-bg-white tw-rounded-xl md:tw-rounded-2xl tw-border tw-overflow-hidden tw-transition-all tw-duration-300 tw-cursor-pointer ${
                    activeFaq === index 
                      ? 'tw-border-emerald-500 tw-shadow-md tw-shadow-emerald-500/10' 
                      : 'tw-border-slate-200 hover:tw-border-slate-300'
                  }`}
                >
                  <div className="tw-p-5 md:tw-p-6 tw-flex tw-justify-between tw-items-center">
                    <h4 className="tw-text-sm md:tw-text-base tw-font-semibold tw-text-slate-900 tw-m-0 tw-pr-4">
                      {faq.q}
                    </h4>
                    <span className={`tw-text-xl md:tw-text-2xl tw-transition-transform tw-duration-300 ${activeFaq === index ? 'tw-text-emerald-500 tw-rotate-45' : 'tw-text-slate-400'}`}>
                      +
                    </span>
                  </div>
                  <div 
                    className="tw-overflow-hidden tw-transition-all tw-duration-300 tw-ease-in-out"
                    style={{ maxHeight: activeFaq === index ? '300px' : '0px' }}
                  >
                    <p className="tw-px-5 md:tw-px-6 tw-pb-5 md:tw-pb-6 tw-pt-0 tw-m-0 tw-text-sm md:tw-text-base tw-text-slate-600 tw-leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* 🌟 5. APP VERSION FOOTER */}
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-8 tw-border-t tw-border-slate-200">
          <div className="tw-bg-slate-200 tw-p-2 tw-rounded-full tw-mb-3">
            <svg className="tw-w-6 tw-h-6 tw-text-slate-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <p className="tw-text-xs md:tw-text-sm tw-font-bold tw-text-slate-400 tw-tracking-widest tw-uppercase tw-m-0">
            iParking Version 1.0.4 (Production)
          </p>
        </div>

      </div>
    </div>
  );
};

export default SupportPage;